import i18n from '@/i18n'
import { _plus, _minus, _times, _percentage, _toFixed } from '@/helpers/bigNumber'

export const type = state => (key) => {
  return state._[key].type
}

export const discountClass = state => (key) => {
  return state._[key].class
}

export const description = state => (key) => {
  return state._[key].description
}

export const percent = state => (key) => {
  return _toFixed(state._[key].percent, 4)
}

export const getAmount = state => (key) => {
  return _toFixed(state._[key].amount, 2)
}

export const base = state => {
  return state.base
}

export const amount = state => (key, value) => {
  if (state._[key].percent === null || state._[key].percent === undefined || state._[key].percent === 0) {
    return _times(state._[key].amount)
  } else {
    return _times(state.base, _percentage(Number(state._[key].percent)))
  }
}

export const formatBase = (state) => {
  return i18n.n(state.base, 'currency')
}

export const formatAmount = (state, getters) => (key) => {
  return i18n.n(getters.amount(key), 'currency')
}

export const itemAmount = state => (key) => {
  return _toFixed(state._[key].amount, 2)
}
export const itemBase = state => (key) => {
  return state._[key].base
}

export const getList = state => {
  return state.list
}

export const getArray = state => {
  return state.list.map(k => {
    return state._[k]
  })
}

export const total = (state, getters) => {
  return _toFixed(state.list.reduce((acc, k) => {
    return getters['type'](k) === '1'
      ? _plus(acc, Number(getters['amount'](k)))
      : _minus(acc, Number(getters['amount'](k)))
  }, 0), 2)
}

export const totalPercent = (state, getters) => {
  return state.list.reduce((acc, k) => {
    return getters['type'](k) === '1'
      ? _plus(acc, Number(getters['percent'](k)))
      : _minus(acc, Number(getters['percent'](k)))
  }, 0)
}

export const totalAmount = (state, getters) => {
  return state.list.reduce((acc, key) => {
    return getters['type'](key) === '1'
    ? _plus(acc, Number(getters['amount'](key)))
    : _minus(acc, Number(getters['amount'](key)))
  }, 0)
}

export const apificate = (state, getters) => {
  return state.list.map(k => {
    let discount = Object.assign({}, state._[k])
    discount.base = state.base
    discount.amount = _toFixed(getters['amount'](k), 2)
    return discount
  })
}
